import { useLocation } from "react-router-dom";
import { Header } from "@layouts/Header";
import BusinessHeader from "@/features/business/components/business-header";
import characterImage from "@assets/images/not-found-character.png";

export function NotFoundHero() {
  const location = useLocation();
  const isBusiness = location.pathname.startsWith("/business");

  return (
    <section className="w-full bg-[#706f6f] overflow-x-clip">
      <div className="w-full max-w-[1728px] mx-auto flex flex-col items-center py-8 px-4 md:px-8 lg:px-[30px] gap-12">
        {/* Header — contextual based on URL */}
        <div className="w-full max-w-[1368px] relative z-20">
          {isBusiness ? <BusinessHeader /> : <Header />}
        </div>

        {/* Hero Content */}
        <div className="w-full max-w-[1368px] relative flex items-start py-12 md:py-16 lg:py-[88px]">
          {/* Text */}
          <div className="flex-1 flex flex-col items-start gap-6 max-w-full lg:max-w-[847px] z-[1]">
            <h1 className="text-[36px] md:text-[52px] lg:text-[76px] font-bold tracking-[-0.04em] text-white font-albert-sans leading-[1.1]">
              Oops! The page you are looking for doesn't exist.
            </h1>
            <p className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-white/75 font-albert-sans leading-[1.4]">
              It may have been moved, updated, or no longer available.
              Please check the URL or use the navigation below to continue browsing
            </p>
          </div>

          {/* Character Image — hidden on mobile */}
          <img
            src={characterImage}
            alt=""
            className="hidden md:block absolute top-[-77px] right-[-51px] w-[340px] md:w-[450px] lg:w-[678px] h-auto object-cover z-0"
          />
        </div>
      </div>
    </section>
  );
}
